import { render, staticRenderFns } from "./ModalPageTemplate.vue?vue&type=template&id=c298a71c&scoped=true"
import script from "./ModalPageTemplate.vue?vue&type=script&lang=js"
export * from "./ModalPageTemplate.vue?vue&type=script&lang=js"
import style0 from "./ModalPageTemplate.vue?vue&type=style&index=0&id=c298a71c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c298a71c",
  null
  
)

export default component.exports